export const TROLLEY_TEXT = {
  each: 'each',
  estimated: 'est.',
  itemPrice: 'Item price',
  pricePer: 'Price per unit',
  qty: 'Qty',
  viewLink: 'View product',
};
